import { render, staticRenderFns } from "./Background.vue?vue&type=template&id=0a999a66&scoped=true&"
var script = {}
import style0 from "./Background.vue?vue&type=style&index=0&id=0a999a66&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a999a66",
  null
  
)

export default component.exports